<template lang="pug">
native-app-list-item(@click="viewOrderDetails")
  .order-details
    .order-number {{ order.orderId }}
      span.order-date {{ orderDate() }}
    .order-grand-total {{ $rogue.currency(order.totals.grandTotalIncludingTax) }}
</template>

<script setup lang="ts">
import { date }          from 'Src/js/helpers/date'
import { messages }      from 'Src/js/app-bridge/messages'
import NativeAppListItem from 'Src/js/pages/_rg-app/components/native-app-list-item.vue'
import { useRouter } from 'vue-router'
import { useRogue } from '@/js/services/Rogue'

const props = defineProps({
  order: {
    type     : Object,
    required : true,
  },
})

const rogue = useRogue()
const router = useRouter()

function orderDate() {
  return date(props.order.createdAt, navigator.language, true)
}

async function viewOrderDetails() {
  if (rogue.isApp('3.4.0')) {
    await router.push({ name: 'myAccountOrderDetail', params: { id: props.order.orderId } })
  } else {
    rogue.emitToApp(messages.OPEN_IN_WEBVIEW, { url: `/account/order/${props.order.orderId}` })
  }
}
</script>

<style scoped lang="scss">
.order-details {
  height: $size-s;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.order-date {
  font-size: $size-xs;
  color: $color-gray-dark;
  margin-left: $space-xxs;
}
</style>
